// §N — preview-as-crew: a DEDICATED, non-persisting Supabase client for
// /crew/preview/:userId (D-e). The owner's access token arrives in the URL
// fragment (stripped before first paint by CrewPortalPage) and travels ONLY as
// this client's Authorization header. Never `setSession()` on the global client:
// authStore.onAuthStateChange → fetchUserAndBusiness and App.tsx's
// useActiveBusinessStore.hydrate() would fire, and the owner's session would be
// persisted into the WebView's localStorage. A preview is one read.
import { createContext } from 'react';
import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { getOrCreateSessionToken } from '../../lib/sessionToken';

export function makePreviewClient(accessToken: string): SupabaseClient {
  return createClient(
    import.meta.env.VITE_SUPABASE_URL,
    import.meta.env.VITE_SUPABASE_ANON_KEY,
    {
      auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false },
      global: {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'X-Session-Token': getOrCreateSessionToken(),
        },
      },
    },
  );
}

// §N — preview-as-crew read-only flag. CrewPortalPage provides it around the
// tab body so the owner's preview reaches ChecklistSection without threading a
// prop through TodayView/JobHeroCard. Default false = the live portal.
// (Lives here, not in a component file — react-refresh/only-export-components.)
export const PreviewReadOnlyContext = createContext(false);
